import { InfoDialog } from '@strata/react-dialog';
import { TextArea } from '@strata/react-inputs';
import { type ComponentProps } from 'react';

interface MessagePreviewModalProps {
    message?: {
        body?: object | string;
        error?: object;
    };
    onClose: ComponentProps<typeof InfoDialog>['onClose'];
}

export const MessagePreviewModal = ({ message = undefined, onClose }: MessagePreviewModalProps) => {
    const { body, error } = message ?? {};
    return (
        <InfoDialog
            dialogTitle="Message Body Preview"
            isOpen={!!message}
            onClose={onClose}
            dialogContent={
                error ? (
                    <>
                        <div className="padding__bottom--small">
                            There was an error when trying to parse this message as JSON.
                        </div>
                        <TextArea
                            id="messagePreview"
                            name="messagePreview"
                            label="Unparsed Message"
                            value={
                                typeof body === 'object' ? JSON.stringify(body, undefined, 4) : body
                            }
                        />
                        <TextArea
                            id="errorPreview"
                            name="errorPreview"
                            label="Error"
                            value={JSON.stringify(error, undefined, 4)}
                        />
                    </>
                ) : (
                    <TextArea
                        id="messagePreview"
                        name="messagePreview"
                        value={JSON.stringify(body, undefined, 4)}
                    />
                )
            }
            width={1000}
        />
    );
};
